import './style.css';
import { Flex } from '@chatui/core';

export const GridLoader = () => {
  return (
    <div className="lds-grid loader">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export const SoundwaveLoader = () => {
  return (
    <div className="soundwave-loader loader">
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export const EllipsisLoader = () => {
  return (
    <div className="lds-ellipsis loader">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export const AudioPlayingLoader = () => {
  return (
    <div className="audio-playing-loader loader">
      <span />
      <span />
      <span />
    </div>
  );
};

export const AudioRecordingLoader = () => {
  return (
    <div className="composer-loader">
      <div className="recording-loader">
        <div className="recording-circle"></div>
        <div className="loading-text">Recording...</div>
      </div>
    </div>
  );
};

export const BotProcessingLoader = () => {
  return (
    <div className="composer-loader ">
      <div className="bot-processing-loader">
        <div className="processing-icon"></div>
      </div>
    </div>
  );
};

export const RecorderWaitingLoader = () => {
  return (
    <div className="composer-loader ">
      <div className="recorder-waiting-loader">
        <div className="progress-icon"></div>
      </div>
    </div>
  );
};

export const DotLoader = () => {
  return (
    <Flex center>
      <span className="dot-loader"></span>
    </Flex>
  );
};
